import { render, staticRenderFns } from "./CreateSKU.vue?vue&type=template&id=1153e61d"
import script from "./CreateSKU.vue?vue&type=script&lang=js"
export * from "./CreateSKU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports